/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ cap: NonNullable<unknown> }} Sub_Quotas_Over_Budget_ExplainInputs */



/**
* | output |
* | --- |
* | "Your token pool is fixed by seat count, so raising the budget sets the overage limit to {cap}, billed on top of your subscription." |
*
* @param {Sub_Quotas_Over_Budget_ExplainInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const sub_quotas_over_budget_explain = /** @type {((inputs: Sub_Quotas_Over_Budget_ExplainInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sub_Quotas_Over_Budget_ExplainInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Ihr Token-Pool ist durch die Anzahl der Sitze festgelegt. Eine Erhöhung des Budgets setzt daher das Überschreitungslimit auf ${i?.cap}, das zusätzlich zu Ihrem Abonnement abgerechnet wird.`)
	return /** @type {LocalizedString} */ (`Your token pool is fixed by seat count, so raising the budget sets the overage limit to ${i?.cap}, billed on top of your subscription.`)
});